<template>
	<div class="form-group">
		<template v-if="required">
			<label class="form-label">{{ label }} <span class="text-danger">*</span></label>
			<div class="input-icon">
				<span class="input-icon-addon">
					<i class="fa fa-square" :style="'color:'+inputData+';' "></i>
				</span>
				<input type="text" class="form-control" :name="name" v-model="inputData" :placeholder="'Enter '+label" v-validate="'required'">
			</div>
			<small class="d-block text-danger">{{ errors.first(name) }}</small>
		</template>
		<template v-else>
			<label class="form-label">{{ label }}</label>
			<div class="input-icon">
				<span class="input-icon-addon">
					<i class="fa fa-square"></i>
				</span>
				<input type="text" class="form-control" :name="name" v-model="inputData" :placeholder="'Enter '+label">
			</div>
		</template>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'ColorField',
	inject: ['$validator'],
	props: {
		data: String,
		name: String,
		label: String,
		required: Boolean
	},
	data() {
		return {
			inputData: ""
		}
	},
	mounted() {
		this.$root.$on('reset-validation', () => {
			// Reset Vee Validate
			this.$validator.reset();
		});
	},
	methods: {
		
	},
	watch: {
		inputData: {
			handler: function() {
				this.$emit('update:value', this.inputData)
			},
			deep: true
		},
		data: function() {
			this.inputData = this.data;
		}
	}
}
</script>